<template>
    <div class="category-page-skeleton" aria-hidden="true">
        <div class="category-page-skeleton-image"></div>
        <div class="category-page-skeleton-line"></div>
        <div class="category-page-skeleton-line short"></div>
        <div class="category-page-skeleton-line short"></div>
        <div class="category-page-skeleton-price"></div>
        <div class="category-page-skeleton-button"></div>
    </div>
</template>
<script>
export default { name: "ProductCardSkeleton" };
</script>
